var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-form" },
    [
      _c(
        "transition-group",
        { attrs: { name: "slide-fade" } },
        [
          !_vm.isSend
            ? _c(
                "v-row",
                {
                  key: "row-before-send",
                  staticClass: "contact-form__form-wrapper",
                  attrs: { variant: "flex" }
                },
                [
                  _c(
                    "v-column",
                    { attrs: { large: 12 } },
                    [
                      _c("v-content-section", {
                        staticClass: "contact-form__head",
                        attrs: { content: _vm.content, variant: "black" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-column",
                    { attrs: { large: 6, phone: 12 } },
                    [
                      _c("v-input", {
                        ref: "nameInput",
                        staticClass: "input",
                        attrs: {
                          disabled: _vm.isDisabledAll,
                          "original-value": _vm.form.name,
                          placeholder: _vm.$t("common.input.name.placeholder"),
                          tabIndex: 1,
                          validation: ["required", "maxLength|255"]
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-input", {
                        ref: "emailInput",
                        staticClass: "input",
                        attrs: {
                          disabled: _vm.isDisabledAll,
                          "original-value": _vm.form.email,
                          placeholder: _vm.$t("common.input.email.placeholder"),
                          tabIndex: 2,
                          validation: ["required", "email", "maxLength|255"]
                        },
                        model: {
                          value: _vm.form.email,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "email", $$v)
                          },
                          expression: "form.email"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-input", {
                        ref: "phoneInput",
                        staticClass: "input",
                        attrs: {
                          disabled: _vm.isDisabledAll,
                          "original-value": _vm.form.phone,
                          placeholder: _vm.$t("common.input.phone.placeholder"),
                          tabIndex: 2,
                          validation: ["required", "phone", "maxLength|255"]
                        },
                        model: {
                          value: _vm.form.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-select", {
                        ref: "topicInput",
                        attrs: {
                          "default-option": _vm.form.options[0].value,
                          disabled: _vm.isDisabledAll,
                          "on-change": function() {},
                          options: _vm.form.options,
                          required: true,
                          tabIndex: 3,
                          variant: "simple"
                        },
                        model: {
                          value: _vm.form.topic,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "topic", $$v)
                          },
                          expression: "form.topic"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-column",
                    { attrs: { large: 6, phone: 12 } },
                    [
                      _c("v-textarea", {
                        ref: "messageInput",
                        attrs: {
                          disabled: _vm.isDisabledAll,
                          placeholder: _vm.$t(
                            "common.input.message.placeholder"
                          ),
                          tabIndex: 5,
                          validation: ["required", "maxLength|1000"]
                        },
                        model: {
                          value: _vm.form.message,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "message", $$v)
                          },
                          expression: "form.message"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-column",
                    { attrs: { large: 12 } },
                    [
                      _c(
                        "v-row",
                        { attrs: { variant: "flex", vertical: "center" } },
                        [
                          _c(
                            "v-column",
                            { attrs: { large: 6, phone: 12 } },
                            [
                              _c("v-checkbox", {
                                ref: "agreeInput",
                                attrs: {
                                  disabled: _vm.isDisabledAll,
                                  "is-checked": _vm.form.agree,
                                  label: _vm.$t("contactForm.agree", {
                                    link:
                                      _vm.getPdfPath +
                                      "20220612_Skatra_ApS_Privacy_Policy.pdf"
                                  }),
                                  required: true,
                                  tabIndex: 4
                                },
                                model: {
                                  value: _vm.form.agree,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "agree", $$v)
                                  },
                                  expression: "form.agree"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-column",
                            { attrs: { large: 6, phone: 12 } },
                            [
                              _c(
                                "v-button",
                                {
                                  class: [
                                    "contact-form__submit",
                                    {
                                      "is-loading": this.isLoading
                                    }
                                  ],
                                  attrs: {
                                    "on-click": _vm.handleSubmit,
                                    variant: "primary"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("common.submit")) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "v-row",
                {
                  key: "row-after-send",
                  staticClass: "contact-form__form-wrapper",
                  attrs: { variant: "flex" }
                },
                [
                  _c(
                    "v-column",
                    { attrs: { large: 12 } },
                    [
                      _c("v-icon", {
                        staticClass: "contact-form__icon",
                        attrs: { name: "ui/thanks" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-column",
                    { staticClass: "text-center", attrs: { large: 12 } },
                    [
                      _c("v-typo", {
                        staticClass: "contact-form__success-headline",
                        attrs: { variant: "h2" },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("contactForm.success.headline")
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-typo",
                        {
                          staticClass: "contact-form__success-perex",
                          attrs: { variant: "body-perex" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t("contactForm.success.text")) +
                              "\n\t\t\t\t"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-button",
                        {
                          staticClass: "contact-form__success-button",
                          attrs: { to: _vm.path("index"), variant: "primary" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t("button.backToHomepage")) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }